import { fromJS} from 'immutable'
import actionTypes from '../actionTypes'

const defaultStatus = fromJS ({
  userName: fromJS({}),
  questionOne: fromJS({}),
  answerOne: fromJS({}),
  questionTwo: fromJS({}),
  answerTwo: fromJS({}),
  saveInCheckQuestion:fromJS({})
})

export default (state = defaultStatus, action) => {
  switch (action.type) {
    case actionTypes.UserName:
      return state.merge({
        userName: fromJS(action.data),
      });
    case actionTypes.QuestionOne:
      return state.merge({
        questionOne: fromJS(action.data),
      });
    case actionTypes.QuestionTwo:
      return state.merge({
        questionTwo: fromJS(action.data),
      });

    default:
      break;
  }

  return state
}